import get from 'lodash/get';
import siteData from '../site_data_util';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};

  return baseSeoUtil({
    site,
    siteConf,
    title: 'Product Index',
    url: 'https://www.fastcompany.com/stuff',
    description:
      'A list of products Co.Design has featured including finalists and winners of Innovation by Design Awards',
    articleSection: 'Product Index',
    config: state.config
  });
}
